﻿function cbPipelineInitial_onDataBound() {
    window.cbPipelineInitial.select(0);
    window.btCreatePipelineEntity.enable(true);
}

function cbPipelineInitial_onChange() {
    if (!window.cbPipelineInitial.dataItem()) {
        window.cbPipelineInitial.select(0);
    }
}

function getInitialPipelineWindow(title: string = 'Выбор воронки') {
    let pipelineWindow = $('#pipelineWindow').data('kendoWindow');
    if (!pipelineWindow) {
        pipelineWindow = $('<div id="pipelineWindow"></div>').kendoWindow({
            ...window.kendoWindowOptions,
            pinned: true,
            width: '500px',
            title,
            scrollable: false
        }).data('kendoWindow');
    }

    return pipelineWindow;
}

function selectInitialPipeline(entityTypes: any[], callBack: Function, ids: any[] | null = null) {
    const popup = getInitialPipelineWindow();

    btCreatePipelineEntity_onClick = () => {
        const combo = $('#cbPipelineInitial').data('kendoComboBox');
        callBack(combo?.value() ?? '');
        $('#pipelineWindow').data('kendoWindow')?.close();
    };
    popup?.refresh({
        url: `/Pipeline/InitialPipeline`,
        type: 'POST',
        data: {
            entityTypes: !Array.isArray(entityTypes) ? [entityTypes] : entityTypes,
            ids: ids
        }
    });
    popup?.center();
    popup?.open();
}

function setComboBoxBackColor(combo: kendo.ui.ComboBox, color: string) {
    if (color) {
        combo.wrapper.find('.k-input-inner').css('background', `#${color}`);
    }
}

function pipelineStatus_onDataBound(e: kendo.ui.ComboBoxDataBoundEvent) {
    const combo = e.sender;
    const dataItem = combo.dataItem();

    if (dataItem) {
        setComboBoxBackColor(combo, dataItem);
    }
}

function setGridPipelineStatusBackColor(grid: kendo.ui.Grid, fieldName: string, colorFieldName: string) {
    if (!grid || !fieldName || !colorFieldName) return;

    let statusColumnIndex = window.getColumnIndexByField(grid, fieldName);
    if (statusColumnIndex !== -1) {
        const rows = statusColumnIndex < -1 ? grid.lockedTable.children().last().children() : grid.tbody.children();
        statusColumnIndex = statusColumnIndex < -1 ? -statusColumnIndex - 2 : statusColumnIndex;

        for (let i = 0; i < rows.length; i++) {
            const row = $(rows[i]);
            const dataItem = grid.dataItem(row);

            if (dataItem && !row.hasClass('k-group-footer') && !row.hasClass('k-grouping-row')) {
                const statusCellStyle = row.children().eq(statusColumnIndex)[0]?.style;
                if (statusCellStyle) {
                    const color = dataItem.get(colorFieldName);
                    if (color) {
                        statusCellStyle.setProperty('background', `#${color.replace('#', '')}`, 'important');

                        if (color === '000000') {
                            statusCellStyle.setProperty('color', '#fff');
                        }
                    }
                }
            }
        }
    }
}

// Чтобы вешать событие на кнопку еще до загрузки кнопки
var btCreatePipelineEntity_onClick: () => void;

// для _IHasPipelineDict
var ihaspipelinedict_cbStatus: any;
var ihaspipelinedict_cbStatus_value: any;
var ihaspipelinedict_entityType: any;
var ihaspipelinedict_entityId: any;

function ihaspipelinedict_pipelineStatus_onDataBound(e: any) {
    const cbStatus = e.sender;
    setTimeout(() => {
        var dataItem = cbStatus.dataItem();
        if (dataItem?.Color)
            setComboBoxBackColor(cbStatus, dataItem.Color);
    }, 500);
    const data = ihaspipelinedict_getDataForStatusChange(e);
    ihaspipelinedict_entityType = data['EntityType'];
    ihaspipelinedict_entityId = data['Id'];
}

function ihaspipelinedict_btVisualizationModeonClick() {
    if (window.ihaspipelinedict_traceWindow.options.visible) {
        window.ihaspipelinedict_traceWindow.close();
    }
    else {
        window.rebindDataSource(window.ihaspipelinedict_grPipelineTraces);
        window.ihaspipelinedict_traceWindow.center().open();
    }
}

function ihaspipelinedict_grPipelineTraces_onDataBound(e: any) {
    setGridPipelineStatusBackColor(e.sender, 'FromStatus', 'FromStatusColor');
    setGridPipelineStatusBackColor(e.sender, 'ToStatus', 'ToStatusColor');
}

function ihaspipelinedict_grPipelineTraces_onRequestEnd(e: kendo.data.DataSourceRequestEndEvent) {
    window.backDataSource_onRequestEnd(e, window.ihaspipelinedict_grPipelineTraces);
}

function ihaspipelinedict_cbStatus_onChange(e: any) {
    const data = ihaspipelinedict_getDataForStatusChange(e);
    const statusChangeEventData = {
        OldStatusId: ihaspipelinedict_cbStatus_value,
        NewStatusId: this.value()
    };

    ihaspieplinedict_changeStatus(data, e, statusChangeEventData);
}

function ihaspieplinedict_changeStatus(data: any, e: any, statusChangeEventData: any) {
    e.sender.close();
    e.sender.enable(false);

    if (data['StatusId'] !== '0' && data['StatusId'] !== '') {
        const url = '/PipelineStatus/UpdateEntityStatus';
        window.ajaxPost(url, data, (response): undefined => {
            if (response.Message) {
                window.swal.fire('Внимание!', response.Message, 'warning');
                e.sender.value(ihaspipelinedict_cbStatus_value);
                e.preventDefault();
            }
            else {
                ihaspipelinedict_cbStatus_value = statusChangeEventData.NewStatusId;
                setTimeout(() => window.rebindDataSource(e.sender), 500);
                setTimeout(() => window.rebindDataSource(window.ihaspipelinedict_grPipelineTraces), 5000);
            }

            e.sender.enable(true);
        });
    }
}

function ihaspipelinedict_getDataForStatusChange(e: any) {
    const parentElement = e.sender.element.parent().parent().parent();
    return {
        'Id': parentElement.find('#Id').val(),
        'StatusId': e.sender.value(),
        'EntityType': Number(parentElement.find('#EntityType').val())
    };
}

window.getInitialPipelineWindow = getInitialPipelineWindow;
window.cbPipelineInitial_onChange = cbPipelineInitial_onChange;
window.ihaspieplinedict_changeStatus = ihaspieplinedict_changeStatus;
window.ihaspipelinedict_btVisualizationModeonClick = ihaspipelinedict_btVisualizationModeonClick;
window.ihaspipelinedict_cbStatus_onChange = ihaspipelinedict_cbStatus_onChange;
window.ihaspipelinedict_getDataForStatusChange = ihaspipelinedict_getDataForStatusChange;
window.ihaspipelinedict_grPipelineTraces_onDataBound = ihaspipelinedict_grPipelineTraces_onDataBound;
window.ihaspipelinedict_grPipelineTraces_onRequestEnd = ihaspipelinedict_grPipelineTraces_onRequestEnd;
window.ihaspipelinedict_pipelineStatus_onDataBound = ihaspipelinedict_pipelineStatus_onDataBound;
window.pipelineStatus_onDataBound = pipelineStatus_onDataBound;
window.selectInitialPipeline = selectInitialPipeline;
window.setComboBoxBackColor = setComboBoxBackColor;
window.setGridPipelineStatusBackColor = setGridPipelineStatusBackColor;
window.cbPipelineInitial_onDataBound = cbPipelineInitial_onDataBound;